<template>
    <div v-loading="loadingInv">
        <div class="page-invoice scrollable">
            <div class="toolbar-mon" v-if="!showAlert">
                <el-row>
                    <el-col>
                        <el-tabs v-model="tabs" type="border-card" @tab-click="tabClick">
                            <!-- <el-tab-pane label="Monthly Usage" name="monthly">
                                <el-row>
                                    <el-col>
                                        <el-row>
                                            <el-col style="text-align: left;">
                                                <h1>Monthly Usage Monitoring</h1>
                                            </el-col>
                                        </el-row>
                                        <el-row style="padding: 20px 0 20px 0;">
                                            <el-col :span="12">
                                                <div>
                                                    <el-select v-model="selectedMonth" placeholder="Select Month" style="float:left; margin: 5px 10px 5px 0;">
                                                        <el-option
                                                        v-for="item in options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value"
                                                        :disabled="item.disabled">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <el-button type="info" @click="changeFilter" style="float:left; margin: 5px 0 5px 0;" :loading="btnLoading" round>Search</el-button>
                                                </div>
                                                <div >
                                                    <el-button @click="syncData" style="margin: 5px 0 5px 10px; background-color: #7E7BF2; color: #FFFFFF;" :loading="loadingSync" round ><b>Sync Data</b></el-button>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row style="padding: 20px 0 20px 0;" v-if="!showAlert">
                                            <el-col>
                                                <el-table
                                                    :data="table"
                                                    :cell-class-name="`cell-custom`"
                                                    style="width: 100%; text-align: left;">
                                                    <el-table-column
                                                    label="Service Name"
                                                    width="280"
                                                    fixed="left">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number">{{scope.row.customerName}} ({{scope.row.customerNumber}})</div>
                                                                </el-col>
                                                                <el-col :span="24"><span >{{scope.row.productName}} ({{scope.row.productType}})</span></el-col>
                                                                <el-col :span="24"><span >National</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style=" visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 55px;" :span="24"><span style=";">International</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Type Quota"
                                                    width="150">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="24">
                                                                <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                            </el-col>
                                                            <el-col :span="24"><div style="visibility: hidden;"></div></el-col>
                                                            <el-col :span="24"><span >CBP</span></el-col>
                                                            <el-col :span="24"><span >BI</span></el-col>
                                                            <el-col :span="24"><span >UI</span></el-col>
                                                            <el-col style="padding-top: 15px;" :span="24"><span style=";">CBP (INT)</span></el-col>
                                                            <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                        </el-row>
                                                    </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Topup Quota"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div  class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.cbp_quota || 0}}</span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.bi_quota || 0}}</span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.ui_quota || 0}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.international_quota || 0}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Limit Quota"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.cbp_limit || 0}}</span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.productType == 'CBP Invoice' || scope.row.is_bi_max == 'true' ? 'MAX': scope.row.bi_limit}}</span></el-col>
                                                                <el-col :span="24"><span >{{scope.row.productType == 'CBP Invoice' || scope.row.is_ui_max == 'true' ? 'MAX': scope.row.ui_limit}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.international_limit || 0}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Ussage Quota"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.cbp_usage + scope.row.cbp_ctwa|| 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.bi_usage + scope.row.bi_ctwa|| 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.ui_usage + scope.row.ui_ctwa || 0}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.international_usage + scope.row.international_ctwa || 0}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                     <el-table-column
                                                    label="Free Entry Point"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.cbp_ctwa || 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.bi_ctwa || 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.ui_ctwa || 0}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.international_ctwa|| 0}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Ratio Usage"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span>{{ countRatio(scope.row.cbp_usage, scope.row.cbp_limit, scope.row.cbp_quota ) }}</span></el-col>
                                                                <el-col :span="24"><span>{{ countRatio(scope.row.bi_usage, scope.row.bi_limit, scope.row.bi_quota ) }}</span></el-col>
                                                                <el-col :span="24"><span>{{ countRatio(scope.row.ui_usage, scope.row.ui_limit, scope.row.ui_quota ) }}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{ countRatio(scope.row.international_usage, scope.row.international_limit, scope.row.international_quota ) }}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Traffic Type"
                                                    width="150">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 40px;" :span="24"><span>HSM</span></el-col>
                                                                <el-col :span="24"><span>Interactive</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>INT - HSM</span></el-col>
                                                                <el-col :span="24"><span>INT - Interactive</span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Traffic Transaction"
                                                    width="150"
                                                    >
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 40px;" :span="24"><span>{{scope.row.traffic.national.hsm || 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.traffic.national.interactive || 0}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.traffic.international.hsm || 0}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.traffic.international.interactive || 0}}</span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-tab-pane> -->

                            <!-- <el-tab-pane label="Daily Usage" name="daily">
                                <el-row>
                                    <el-col>
                                        <el-row>
                                            <el-col style="text-align: left;">
                                                <h1>Daily Usage Monitoring</h1>
                                            </el-col>
                                        </el-row>
                                        <el-row style="padding: 20px 0 20px 0;">
                                            <el-col>
                                                <div style="display: inline-block;">
                                                    <el-date-picker
                                                        style="width:320px;"
                                                        v-model="selectedStartDate"
                                                        range-separator="-"
                                                        size="medium"
                                                        type="daterange"
                                                        :picker-options="pickerOptions"
                                                        placeholder="Pick a day">
                                                    </el-date-picker>
                                                </div>
                                                <div style="display: inline-block;">
                                                    <el-button type="info" @click="changeFilterDaily" style="margin: 5px 0 5px 1em;" :loading="btnLoading" round>Search</el-button>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <el-row style="padding: 20px 0 20px 0;" v-if="!showAlert">
                                            <el-col>
                                                <el-table
                                                    :data="table"
                                                    :cell-class-name="`cell-custom`"
                                                    style="width: 100%; text-align: left;">
                                                    <el-table-column
                                                    label="Service Name"
                                                    width="280"
                                                    fixed="left">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number">{{scope.row.customerName}} ({{scope.row.customerNumber}})</div>
                                                                </el-col>
                                                                <el-col :span="24"><span >{{scope.row.productName}} ({{scope.row.productType}})</span></el-col>
                                                                <el-col :span="24"><span >National</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style=" visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style=" visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 90px;" :span="24"><span style=";">International</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Type Quota"
                                                    width="250">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="24">
                                                                <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                            </el-col>
                                                            <el-col :span="24"><div style="visibility: hidden;"></div></el-col>
                                                            <el-col style="padding-top: 25px;" :span="24"><span >CBP-BI</span></el-col>
                                                            <el-col :span="24"><span >BI</span></el-col>
                                                            <el-col :span="24"><span >CBP-UI</span></el-col>
                                                            <el-col :span="24"><span >UI</span></el-col>
                                                            <el-col style="padding-top: 15px;" :span="24"><span style=";">CBP (INT)</span></el-col>
                                                            <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                        </el-row>
                                                    </template>
                                                    </el-table-column>
                                                     <el-table-column
                                                    label="Free Entry Point"
                                                    width="250">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div  class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 25px;" :span="24"><span >0</span></el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota.ctwa ? scope.row.quota.ctwa.bi:'0'}}</el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota.ctwa ? scope.row.quota.ctwa.cbp:'0'}}</el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota.ctwa ? scope.row.quota.ctwa.ui:'0'}}</el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.quota.ctwa ? scope.row.quota.ctwa.international :'0'}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Usage Session"
                                                    width="250">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div  class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 25px;" :span="24"><span >{{scope.row.quota ? scope.row.quota.national.cbp.bi:'-'}}</span></el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota ? scope.row.quota.national.bi + scope.row.quota.ctwa.bi:'-'}}</el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota ? scope.row.quota.national.cbp.ui + scope.row.quota.ctwa.cbp:'-'}}</el-col>
                                                                <el-col :span="24"><span ></span>{{scope.row.quota ? scope.row.quota.national.ui + scope.row.quota.ctwa.ui :'-'}}</el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.quota ? scope.row.quota.international.ui + scope.row.quota.international.bi + scope.row.quota.ctwa.international:'-'}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Traffic Type"
                                                    width="250">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 70px;" :span="24"><span>HSM</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 25px;" :span="24"><span>Interactive</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>INT - HSM</span></el-col>
                                                                <el-col :span="24"><span>INT - Interactive</span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                    label="Traffic Transaction"
                                                    width="250">
                                                        <template slot-scope="scope">
                                                            <el-row>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden;">{{ scope.row.productName }}</div>
                                                                </el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 70px;" :span="24"><span>{{scope.row.traffic ? scope.row.traffic.national.hsm:'-'}}</span></el-col>
                                                                <el-col :span="24"><span style="visibility: hidden;"></span></el-col>
                                                                <el-col style="padding-top: 25px;" :span="24"><span>{{scope.row.traffic ? scope.row.traffic.national.interactive: '-'}}</span></el-col>
                                                                <el-col style="padding-top: 15px;" :span="24"><span>{{scope.row.traffic ? scope.row.traffic.international.hsm: '-'}}</span></el-col>
                                                                <el-col :span="24"><span>{{scope.row.traffic ? scope.row.traffic.international.interactive : '-'}}</span></el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-tab-pane> -->

                            <!-- <el-tab-pane label="Transaction Topup" name="topup">
                                <el-row>
                                    <el-col>
                                        <el-row>
                                            <el-col style="text-align: left;">
                                                <h1>Transaction Topup Monitoring</h1>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row style="padding: 20px 0 20px 0;">
                                    <el-col>
                                        <div style="display: inline-block;">
                                            <el-date-picker
                                                style="width:320px;"
                                                v-model="selectedStartDate"
                                                range-separator="-"
                                                size="medium"
                                                type="daterange"
                                                placeholder="Pick a day">
                                            </el-date-picker>
                                        </div>
                                        <div style="display: inline-block;">
                                            <el-button type="info" @click="changeFilterDaily" style="margin: 5px 0 5px 1em;" :loading="btnLoading" round>Search</el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row style="padding: 20px 0 20px 0;" v-if="!showAlert">
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        :page-size="10"
                                        @current-change="paginate"
                                        :current-page="currentPage"
                                        :total="parseInt(totalTrx)">
                                    </el-pagination><br>
                                    <el-table
                                        :data="trx"
                                        stripe
                                        style="width: 100%">
                                        <el-table-column
                                        prop="customerId"
                                        label="Customer ID"
                                        width="180">
                                        </el-table-column>
                                        <el-table-column
                                        prop="customerNumber"
                                        label="Phone Number"
                                        width="180">
                                        </el-table-column>
                                        <el-table-column
                                        prop="updatedAt"
                                        label="Execution Date"
                                        width="200">
                                            <template slot-scope="scope">
                                                {{ formatDate(scope.row.updatedAt, "DD/MM/YYYY HH:mm:ss") }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="productType"
                                        label="Program"
                                        width="250">
                                            <template slot-scope="scope">
                                                <span>Whatsapp Conversation</span>
                                                <br>
                                                <span>({{ scope.row.productType }})</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="topupType"
                                        label="Monitoring"
                                        width="140">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.topupType=='Added'">Addition</span>
                                                <span v-else>Reduction</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="reference"
                                        label="Reference"
                                        width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.reference==null">-</span>
                                                <span v-else>
                                                    {{ scope.row.reference }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="initialQuota"
                                        label="Initial Quota"
                                        width="120">
                                            <template slot-scope="scope">
                                                <div v-for="(c, kc) in scope.row.initialQuotaCBP" :key="kc">
                                                    {{c.type}} : {{c.quota_before}}
                                                </div>
                                                <div v-for="(u, ku) in scope.row.initialQuotaUI" :key="ku">
                                                    {{u.type}} : {{u.quota_before}}
                                                </div>
                                                <div v-for="(b, kb) in scope.row.initialQuotaBI" :key="kb">
                                                    {{b.type}} : {{b.quota_before}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="detail"
                                        label="Credit"
                                        width="120">
                                            <template slot-scope="scope">
                                                <div v-for="(c, cc) in scope.row.creditCBP" :key="cc">
                                                    {{c.type}} : {{c.credit}}
                                                </div>
                                                <div v-for="(u, cu) in scope.row.creditUI" :key="cu">
                                                    {{u.type}} : {{u.credit}}
                                                </div>
                                                <div v-for="(b, cb) in scope.row.creditBI" :key="cb">
                                                    {{b.type}} : {{b.credit}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        prop="detail"
                                        label="Mutation"
                                        width="120">
                                            <template slot-scope="scope">
                                                <div v-for="(c, mc) in scope.row.mutationCBP" :key="mc">
                                                    {{c.type}} : {{c.mutation}}
                                                </div>
                                                <div v-for="(u, mu) in scope.row.mutationUI" :key="mu">
                                                    {{u.type}} : {{u.mutation}}
                                                </div>
                                                <div v-for="(b, mb) in scope.row.mutationBI" :key="mb">
                                                    {{b.type}} : {{b.mutation}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-row>
                            </el-tab-pane> -->

                            <!-- <el-tab-pane label="Synchronize" name="sync">
                                <el-row>
                                    <el-col>
                                        <el-row>
                                            <el-col style="text-align: left;">
                                                <h1>Synchronize Data</h1>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row style="padding: 20px 0 20px 0;">
                                    <el-col>
                                        <div style="display: inline-block;">
                                            <el-date-picker
                                                style="width:320px;"
                                                v-model="selectedStartDate"
                                                range-separator="-"
                                                size="medium"
                                                :picker-options="pickerOptions"
                                                type="daterange"
                                                placeholder="Pick a day">
                                            </el-date-picker>
                                        </div>
                                        <div style="display: inline-block;">
                                        <el-select v-model="fillNumb" placeholder="Number" style="margin: 5px 0 5px 1em; width:150px;" size="medium" :default-first-option="false">
                                            <el-option
                                            v-for="item in numberCustomer"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        </div>
                                        <div style="display: inline-block;">
                                            <el-button  @click="getDataSync" style="margin: 5px 0 5px 1em; background-color:#3576F2; color: #fff;" :loading="btnLoading" round>Search</el-button>
                                        </div>
                                        
                                    </el-col>
                                </el-row>
                                <el-row style="padding: 20px 0 20px 0;" v-if="!showAlert">
                                    <el-dialog :title="`Synchronize History On ${detailNumber}`" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="detailNumber=''">
                                        <el-table 
                                            height="450"
                                            v-loading="loadingDetail"
                                            element-loading-text="Loading..."
                                            element-loading-spinner="el-icon-loading" 
                                            :data="detail">
                                            <el-table-column property="no" label="No" width="50">
                                            </el-table-column>
                                            <el-table-column property="created_at" label="Start Date" width="250">
                                                <template slot-scope="scope">
                                                    {{ formatDate(scope.row.created_at, "DD/MM/YYYY HH:mm:ss") }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="last_run" label="End Date" width="250">
                                                <template slot-scope="scope">
                                                    {{ scope.row.last_run ? formatDate(scope.row.last_run, "DD/MM/YYYY HH:mm:ss"):'-' }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="status" label="Status">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.status == 'In Progress'" type="warning">{{scope.row.status}}</el-tag>
                                                    <el-tag v-else-if="scope.row.status == 'Done'" type="success">{{scope.row.status}}</el-tag>
                                                     <el-tag v-else-if="scope.row.status == 'Failed'" type="danger">{{scope.row.status}}</el-tag>
                                                    <el-tag v-else type="info">{{scope.row.status}}</el-tag>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <span slot="footer" class="dialog-footer">
                                        <el-button @click="dialogFormVisible=false, detailNumber=''">Close</el-button>
                                        </span>
                                    </el-dialog>
                                    <el-table
                                        :data="dataUsage"
                                        :border='false'
                                        >
                                        <el-table-column
                                        prop="no"
                                        label="No"
                                        width="40">
                                        </el-table-column>
                                        <el-table-column
                                        prop="fbbm_id"
                                        label="FBBM_ID"
                                        width="180">
                                        </el-table-column>
                                        <el-table-column
                                        prop="customerNumber"
                                        label="Phone Number"
                                        width="180">
                                        </el-table-column>
                                        <el-table-column label="Damcorp">
                                            <el-table-column
                                                prop="bi_dam"
                                                label="BI"
                                                width="120">
                                            </el-table-column>
                                            <el-table-column
                                            prop="ui_dam"
                                            label="UI"
                                            width="170">
                                            </el-table-column>
                                            <el-table-column
                                            prop="total_dam"
                                            label="Total"
                                            width="170">
                                            </el-table-column>
                                        </el-table-column>
                                        <el-table-column label="Facebook">
                                        <el-table-column
                                        prop="bi_fb"
                                        label="BI"
                                        width="170">
                                        </el-table-column>
                                        <el-table-column
                                        prop="ui_fb"
                                        label="UI"
                                        width="170">
                                        </el-table-column>
                                        <el-table-column
                                        prop="total_fb"
                                        label="Total"
                                        width="170">
                                        </el-table-column>
                                        </el-table-column>
                                        <el-table-column
                                        prop="detail"
                                        label="Sync progress"
                                        align="center"
                                        width="150">
                                        <template slot-scope="scope">
                                                <el-button style="background-color:#7CC97F; color:#fff;" @click="detailSync(scope.row)" :disabled="loadingDetail" size="small" plain>
                                                    Detail
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                        label="#"
                                        width="100">
                                            <template slot-scope="scope">
                                                <el-button v-if="scope.row.running" type="info" :disabled="true" size="small">
                                                    <i class="mdi mdi-sync"></i>Sync
                                                </el-button>
                                                <el-button v-else type="primary" style="background-color:#7CBEFB; border-color:#7CBEFB;" @click="usageSync(scope.row)" :disabled="checkLoadingSync(scope.row)" size="small">
                                                    <i class="mdi mdi-sync"></i> Sync
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-row>
                            </el-tab-pane> -->

                            <el-tab-pane label="Usage Session" name="usageSession">
                                <el-form>
                                    <el-row>
                                        <el-col>
                                            <el-select
                                                size="medium"
                                                class="mr-20"
                                                clearable
                                                v-model="filterCompany"
                                                @change="filterCompanyName"
                                                filterable
                                                placeholder="Company Name"
                                            >
                                                <el-option
                                                    v-for="items in listCustomer"
                                                    :key="items.customer_id"
                                                    :label="items.customer_name"
                                                    :value="items.customer_id"
                                                ></el-option>
                                            </el-select>
                                            <el-select
                                                size="medium"
                                                class="mr-20"
                                                clearable
                                                v-model="filterPhoneNumber"
                                                placeholder="Phone Number"
                                            >
                                                <el-option
                                                    v-for="(items, idx) in listPhoneNumber"
                                                    :key=idx
                                                    :label="items ? items : '-'"
                                                    :value="items"
                                                ></el-option>
                                            </el-select>
                                            <el-date-picker
                                                style="width:320px;"
                                                v-model="selectedStartDate"
                                                range-separator="-"
                                                size="medium"
                                                type="daterange"
                                                :picker-options="pickerOptions"
                                                placeholder="Pick a day"
                                                class="mr-20"
                                            >
                                            </el-date-picker>
                                            <el-button
                                                type="primary"
                                                size="medium"
                                                style="width: 80px;"
                                                @click="getUsageSession"
                                                :loading="btnSearchLoading"
                                            >
                                                Search
                                            </el-button>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-table 
                                            height="250"
                                            v-loading="loadingTable"
                                            element-loading-text="Loading..."
                                            element-loading-spinner="el-icon-loading" 
                                            class="mt-30"
                                            :data="monitoringUsage"
                                        >
                                            <el-table-column prop="market_area_customer" label="Market Area" width="180">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <p v-if="props.row.master_market_area_name">{{ props.row.master_market_area_name }}</p>
                                                        <p v-else>-</p>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="conversation_type" label="Conversation Type" width="200">
                                                <div
                                                    style="height: 13em;"
                                                >
                                                    <table>
                                                        <tr style="background-color: transparent;">
                                                            <td style="border: none;">Authentication</td>
                                                        </tr>
                                                        <tr style="background-color: transparent;">
                                                            <td style="border: none;">Marketing</td>
                                                        </tr>
                                                        <tr style="background-color: transparent;">
                                                            <td style="border: none;">Utility</td>
                                                        </tr>
                                                        <tr style="background-color: transparent;">
                                                            <td style="border: none;">Service</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </el-table-column>
                                            <el-table-column property="postpaid_limit" label="Postpaid Limit" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <table>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.authentication_limit}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.marketing_limit}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.utility_limit}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.service_limit}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="postpaid_usage" label="Postpaid Usage" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <table>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">
                                                                    {{props.row.authentication_usage - props.row.authentication_topup_usage}}
                                                                </td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">
                                                                    {{props.row.marketing_usage - props.row.marketing_topup_usage}}
                                                                </td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">
                                                                    {{props.row.utility_usage - props.row.utility_topup_usage}}
                                                                </td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">
                                                                    {{props.row.service_usage - props.row.service_topup_usage}}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="creadit_balance" label="Creadit Balance" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <table>
                                                            <tr style="background-color: transparent;">
                                                                <el-tooltip
                                                                    class="box-item"
                                                                    effect="dark"
                                                                    placement="top"
                                                                >
                                                                    <template #content>
                                                                        Balance : {{ props.row.authentication_balance }}<br />
                                                                        Usage : {{ props.row.authentication_topup_usage }}<br/>
                                                                        Credit : {{ props.row.authentication_credit }}
                                                                    </template>
                                                                    <td style="border: none;">{{props.row.authentication_balance}}</td>
                                                                </el-tooltip>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <el-tooltip
                                                                    class="box-item"
                                                                    effect="dark"
                                                                    placement="top"
                                                                >
                                                                    <template #content>
                                                                        Balance : {{ props.row.marketing_balance }}<br />
                                                                        Usage : {{ props.row.marketing_topup_usage }}<br/>
                                                                        Credit : {{ props.row.marketing_credit }}
                                                                    </template>
                                                                    <td style="border: none;">{{props.row.marketing_balance}}</td>
                                                                </el-tooltip>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <el-tooltip
                                                                    class="box-item"
                                                                    effect="dark"
                                                                    placement="top"
                                                                >
                                                                    <template #content>
                                                                        Balance : {{ props.row.utility_balance }}<br />
                                                                        Usage : {{ props.row.utility_topup_usage }}<br/>
                                                                        Credit : {{ props.row.utility_credit }}
                                                                    </template>
                                                                    <td style="border: none;">{{props.row.utility_balance}}</td>
                                                                </el-tooltip>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <el-tooltip
                                                                    class="box-item"
                                                                    effect="dark"
                                                                    placement="top"
                                                                >
                                                                    <template #content>
                                                                        Balance : {{ props.row.service_balance }}<br />
                                                                        Usage : {{ props.row.service_topup_usage }}<br/>
                                                                        Credit : {{ props.row.service_credit }}
                                                                    </template>
                                                                    <td style="border: none;">{{props.row.service_balance}}</td>
                                                                </el-tooltip>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="free_entry" label="Free Entry" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <table>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.authentication_ctwa}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.marketing_ctwa}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.utility_ctwa}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.service_ctwa}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="total_usage" label="Total Usage" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                    >
                                                        <table>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.authentication_usage}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.marketing_usage}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.utility_usage}}</td>
                                                            </tr>
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{props.row.service_usage}}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="trafic_type" label="Traffic Type" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                        v-if="dataUsage.length > 0 && dataUsage[props.$index].traffic_type"
                                                    >
                                                        <table
                                                            v-for="(item, idx) in dataUsage[props.$index].traffic_type"
                                                            :key="idx"
                                                        >
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{ item.type }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column property="trafic_transaction" label="Traffic Transaction" width="200">
                                                <template slot-scope="props">
                                                    <div
                                                        style="height: 13em;"
                                                        v-if="dataUsage.length > 0 && dataUsage[props.$index].traffic_type"
                                                    >
                                                        <table
                                                            v-for="(item, idx) in dataUsage[props.$index].traffic_type"
                                                            :key="idx"
                                                        >
                                                            <tr style="background-color: transparent;">
                                                                <td style="border: none;">{{ item.doc_count }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-row>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
                
            </div>
        </div>
        <el-alert title="Info" type="info" description="No Data" show-icon v-if="showAlert"></el-alert>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
import Template from './Template.vue'
const moment = require('moment')
export default {
  components: { Template },
    props: {
        tableData: {
            type: Array,
        },
        totalBilling:{
            type: Number
        },
        showAlert: {
            type: Boolean
        },
        loadingInvoice: {
            type: Boolean
        },
        number:{
            type: Array
        }
    },
    data(){
        return {
            fillNumb:'',
            numberCustomer: [],
            loadingDetail: false,
            detail: [],
            dialogFormVisible: false,
            detailNumber: '',
            formLabelWidth: '200px',
            loadingSync: false,
            pickerOptions: {
				disabledDate: this.disabledDate
			},
            selectedStartDate: [
                moment().format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            totalTrx: 0,
            currentPage: 1,
            tabs:'usageSession',
            today: moment().format("dddd, DD MMM YYYY"),
            getToday: moment().format('DD MMM YYYY'),
            getMonth: moment().month()+1,
            selectedMonth: moment().format("YYYY-MM"),
            btnLoading: false,
            dataBilling: this.billing,
            loadingInv: false,
            dataTotalBilling:this.totalBilling,
            dataNumber: this.number,
            options: [], 
            table:[],
            trx: [],
            dataUsage:[],
            loading: {
                trx: false
            },
            listCustomer: [],
            listPhoneNumber: [],
            filterCompany: '',
            filterPhoneNumber: '',
            dataUsage: [],
            monitoringUsage: [],
            btnSearchLoading: false,
            loadingTable: false
        }
    },
    methods: {
        log(data) {
            console.log(data, " <<data");
        },
        filterCompanyName() {
            this.loadWA(this.filterCompany);
        },
        disabledDate(date) {
			// console.log('date disable', date);
			var today = moment(), diff = today.diff(moment(date), 'd')
						if(moment(date) < moment('2022-02')|| diff < 0){
							return true
						} else {
							if(diff == 0){
								if(today.isSame(moment(date), 'd') == false){
									return true
								} else {
									return false
								}
							}
							return false
						}
			// return new Date() < date
		},
        async tabClick(targetName){
            this.selectedStartDate = [
                moment().format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ]

            switch (targetName.name) {
                case 'monthly':
                    await this.getBilling()
                    break;
                case 'daily':
                    await this.getDaily()
                    break;
                case 'topup':
                    await this.getTrx()
                    break;
                case 'sync':
                    this.fillNumb = ''
                    await this.getDataSync()
                    break;
            }
		},
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        paginate(page){
            this.currentPage = page
            this.getTrx(page)
        },
        countRatio(val1,val2,val3){
            let count = Number(val1)/(Number(val2) + Number(val3)) * 100

            count = count ? Math.floor(count) : 0

            if (isFinite(count) && count <= 100) {
                count += '%'
            }
            else {
                count = '~%'
            }
            return count
        },
        print() {
			window.print()
        },
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
        },
        async changeFilter(){
			await this.getBilling()
        },
        async changeFilterDaily(){
			await this.getDaily()
        },
        async getDaily(query = ""){
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            this.btnLoading = true
            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/daily_usage",
                method: 'post',
                data:{
                    "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                },
                timeout: (10 * 60) * 1000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        this.dataTotalBilling = 0
                        let data = []

                        data = res.data.data.dataUser.map(el => {
                            let product = el.product.find(v => v.productName.toLowerCase() == 'whatsapp conversation')
                            let traffic = res.data.data.traffic.find(val => val.phone_number == el.phone_number)
                            let tempData = {
                                customerName: res.data.data.companyName,
                                customerNumber: el.phone_number,
                                productName: product ? product.productName: '-',
                                productType: product ? product.type: '-',
                                traffic: traffic ? traffic.traffic: null,
                                quota: traffic ? traffic.quota:null
                            }

                            switch (tempData.productType) {
                                case 'notification':
                                    tempData.productType = 'CBP Invoice'
                                    break;
                                case 'notification_caping':
                                    tempData.productType = 'CBP Caping'
                                    break;
                                case 'notification_caping_plafon':
                                    tempData.productType = 'CBP Hybrid'
                                    break;
                            }

                            return tempData
                        })

                        this.table = data

                        // console.log(this.table);
                    }
                } else {
                    // this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.btnLoading = false
				this.loadingInv = false
            })
        },
        async getBilling(query = ""){
            this.table = []
            this.numberCustomer = []
            this.btnLoading = true
            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/monthly_usage",
                method: 'post',
                data:{
                    months: this.selectedMonth,
                    with_date: false
                },
                timeout: (10 * 60) * 1000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        this.dataTotalBilling = 0

                        res.data.data.dataUser.forEach(element => {
                            this.numberCustomer.push({value: element.phone_number, label: element.phone_number})
                        });

                        if (res.data.data.detail) {
                            let datas = res.data.data.detail.count_limit || []

                            if (datas.length > 0) {
                                datas = datas.map(el => {
                                    if (el) {
                                        if (el.productName && el.productName.toLowerCase() == 'whatsapp conversation') {
                                            el.cbp_usage = el.cbp_usage || 0
                                            el.bi_usage = el.bi_usage || 0
                                            el.ui_usage = el.ui_usage || 0
                                            el.international_usage = el.international_usage || 0
    
                                            switch (el.productType) {
                                                case 'notification':
                                                    el.productType = 'CBP Invoice'
                                                    break;
                                                case 'notification_caping':
                                                    el.productType = 'CBP Caping'
                                                    break;
                                                case 'notification_caping_plafon':
                                                    el.productType = 'CBP Hybrid'
                                                    break;
                                            }
    
                                            
                                        }
    
                                        let findTraffic = res.data.data.detail.traffic.find(val => el.customerNumber == val.phone_number) || null
    
                                        el.traffic = findTraffic.traffic
                                    }

                                    return el
                                })

                                datas = datas.filter(v => v != null)
                            }

                            this.table = datas
                            // console.log(this.table);
                        }
                    }
                } else {
                    // this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingInv = false
            })
        },
        checkLoadingSync(data){
            if (data.customerNumber == this.detailNumber) {
                return true
            }
            else {
                return false
            }
        },
        async syncData(query = ""){
            
            // console.log("selected month is",this.selectedMonth)
            let custId = this.$route.params.consumen

            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/jobQuota",
                method: 'post',
                data:{
                    months: moment(this.selectedMonth).format('YYYY-MM'),
                    force: true
                },
                timeout: (10 * 60) * 1000
            }

            this.$swal({
              title: `Are you sure want to sync data in (${moment(this.selectedMonth).format('MMM YYYY')})?`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(async () => {
                this.loadingSync = true
                await api(
                    apiOptions
                )
                .then(res => {
                    if (res.data.ec == 200 && res.data.data.detail) {
                        let today = moment().format('YYYY-MM')
                        if (moment(this.selectedMonth).format('YYYY-MM') != today) {
                            this.syncDataBilling()
                        }
                        else{
                            this.$swal(this.$t('success'), this.$t('success'), "success")
                            this.getBilling()
                            this.loadingSync= false
                        }
                    }
                    // this.loadingSync= false
                })
                .catch(err => {
                    console.log(err)
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    this.btnLoading = false
                    this.loadingSync= false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
            });
            
        },
        async syncDataBilling(query = ""){
            this.loadingSync = true
            // console.log("selected month is",this.selectedMonth)
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/new_billing",
                method: 'post',
                data:{
                    months: moment(this.selectedMonth).format('YYYY-MM'),
                    billing:true,
                    sync: true
                },
                timeout: (10 * 60) * 1000
            }
            await api(
                apiOptions
            )
            .then(res => {
                if (res.data.ec == 200 && res.data.data.length > 0){
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                }
                else{
                    this.$swal(this.$t('error'), "Error sync data billing", "error")
                }
                this.getBilling()
                this.loadingSync= false
            })
            .catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.btnLoading = false
				this.loadingSync= false
            })
        },
        async getDataSync(query = ""){
            this.detailNumber = ""
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            this.btnLoading = true
            // console.log("selected month is",this.selectedMonth)
            this.loadingInv = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/sync_usage",
                method: 'post',
                data:{
                    "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                    "number": this.fillNumb
                },
                timeout: (10 * 60) * 10000
            }
            if(query == "download"){
                apiOptions.url += "?download"
                apiOptions.responseType = 'blob'
            }
            await api(
                apiOptions
            )
            .then(res => {
                let tempNumber = new Array()
                let tempBilling = new Array()
                let i = 0
                let date = ""
                if(res.data.ec == 200 || query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
							if(moment(this.selectedMonth).format("M") == this.getMonth){
								date = this.getToday
							}
							else{
								date = moment(this.selectedMonth).endOf('month').format("DD MMM YYYY")
							}
							const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', 'Report Billing (Platform by DAMCorp)('+date+').xls'); //or any other extension
							link.click();
						} catch(err){
                            // console.log()
							// console.log(err.message)
						}
                    }
                    else{
                        let data = []

                        data = res.data.data.dataUser.map((el,i) => {
                            // this.numberCustomer.push({value: el.phone_number, label: el.phone_number })
                            let product = el.product.find(v => v.productName.toLowerCase() == 'whatsapp conversation')
                            let traffic = res.data.data.traffic.find(val => val.phone_number == el.phone_number)
                            let tempData = {
                                no: `${i+1}.`,
                                fbbm_id: product ? product.fbbm_id : '-',
                                customerName: res.data.data.companyName,
                                customerNumber: el.phone_number,
                                bi_dam: 0,
                                ui_dam:0,
                                total_dam: 0,
                                bi_fb: 0,
                                ui_fb: 0,
                                total_fb: 0,
                                running: traffic.running || null
                                // traffic: traffic ? traffic.traffic: null,
                                // quota: traffic ? traffic.quota:null
                            }

                            if (traffic) {
                                tempData.bi_dam = traffic.quota.national.cbp.bi + traffic.quota.national.bi + traffic.quota.international.bi
                                tempData.ui_dam = traffic.quota.national.cbp.ui + traffic.quota.national.ui + traffic.quota.international.ui
                                tempData.total_dam = tempData.bi_dam + tempData.ui_dam
                                tempData.bi_fb = traffic.fb_bi || 0
                                tempData.ui_fb = traffic.fb_ui || 0
                                tempData.total_fb = tempData.bi_fb + tempData.ui_fb
                            }

                            if (tempData.total_fb <= tempData.total_dam) {
                                tempData.running = true
                            }

                            return tempData
                        })
                        
                        this.dataUsage = data

                        // console.log(this.table);
                    }
                } else {
                    // this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                }
                this.btnLoading = false
                this.loadingInv = false
            })
            .catch(err => {
                console.log(err)
                this.btnLoading = false
				this.loadingInv = false
            })
        },
        async usageSync(data){
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            let custId = this.$route.params.consumen
            this.detailNumber = data.customerNumber
            this.loadingDetail = true
            this.$swal({
              title: `Are you sure want to sync data usage for number (${data.customerNumber})?`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                 let apiOptions = {
                    url: config.baseApi + 'consumen/' + custId + "/insert_sync_usage",
                    method: 'post',
                    data:{
                        "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                        "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                        "number": data.customerNumber
                    },
                    timeout: (10 * 60) * 1000
                }

                api(
                    apiOptions
                )
                .then(res => {
                    if(res.data.ec == 200){
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                    } else {
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    }
                    this.getDataSync()
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                    this.$message({
                        type: 'warning',
                        message: `Syncronize error: ${err}`
                    });
                })
            }).catch(() => {
                this.loadingDetail = false
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
                // this.additionalServiceLoadingButton = false
            });
        },
        async detailSync(data){
            if(!this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                return
            }
            this.loadingDetail = true
            this.dialogFormVisible = true
            this.detailNumber = data.customerNumber
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'consumen/' + custId + "/get_sync_usage",
                method: 'post',
                data:{
                    "startDate":moment(this.selectedStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.selectedStartDate[1]).format("YYYY-MM-DD"),
                    "number": data.customerNumber
                },
                timeout: (10 * 60) * 1000
            }

            await api(
                apiOptions
            )
            .then(res => {
                if(res.data.ec == 200){
                    let datas = res.data.data

                    if (datas.length > 0) {
                        datas = datas.map((el,i) => {
                            el.no = `${i+1}.`
                            switch (el.status) {
                                case 0:
                                    el.status = "Waiting"
                                    break;
                                case 1:
                                    el.status = "In Progress"
                                    break;
                                case 2:
                                    el.status = "Done"
                                    break;
                                case 3:
                                    el.status = "Failed"
                                    break;
                            }

                            return el
                        })
                    }

                    this.detail = datas
                } else {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    this.dialogFormVisible = false
                }
                this.loadingDetail = false
            })
            .catch(err => {
                console.log(err)
                this.loadingDetail = false
            })

        },
        async getTrx(page=1, per_page=10){
            this.loading.trx = true
            let custId = this.$route.params.consumen
            let apiOptions = {
                url: config.baseApi + 'finance/' + custId + "/mutation",
                method: 'get',
                params:{
                    page: page,
                    per_page: per_page
                },
                timeout: (10 * 60) * 1000
            }
            // if(query == "download"){
            //     apiOptions.url += "?download"
            //     apiOptions.responseType = 'blob'
            // }
            await api(
                apiOptions
            ).then(res => {
                this.trx = res.data.data.mutation_data
                this.totalTrx = res.data.data.total
                this.loading.trx = false
            }).catch(err => {
                console.log("err",err)
                this.loading.trx = false
            })
        },
        async getUsageSession(){
            this.btnSearchLoading=true;
            this.loadingTable=true;
            let custId = this.$route.params.consumen
            let data = {
                startDate: this.selectedStartDate[0],
                endDate: this.selectedStartDate[1],
                phone_number: this.filterPhoneNumber
            };

            let apiOptions = {
                url: config.baseApi + `master-consumen/${custId}/daily_usage`,
                method: 'POST',
                data: data
            }
            
            await api(
                apiOptions
            ).then(res => {
                const data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.traffic
                        ? res.data.data.traffic
                        : [];
                const status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;

                if (status === 200) {
                    const monitoring = data[0].monitoring;
                    const usageArr = data[0].usgArr;
                    this.monitoringUsage = monitoring;
                    this.dataUsage = usageArr;
                }
                this.btnSearchLoading=false;
                this.loadingTable=false;
            }).catch(err => {
                console.log("err",err);
                this.btnSearchLoading=false;
                this.loadingTable=false;
            })
        },
        clear(){
            this.selectedMonth = ''
            this.getBilling()
        },
        async loadConsumen() {
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get',
                params: {
                    customer_type: 2
                }
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;
				if(status === 200){
					this.listCustomer = data;
				}
            })
            .catch(err => {
                console.error(err);
            })
        },
        async loadWA(id) {
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
				if(status == 200){
                    this.listPhoneNumber = data;
				} else {
                    this.listPhoneNumber = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		}
    },
    async beforeMount(){
        let d = new Date(2022,2);
        d.setDate(d.getDate()-1);
        
		for(let i = 6; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
            let data = {
				value: moment().subtract(i, 'month').format("YYYY-MM"),
				label: moment().subtract(i, 'month').format("MMM YYYY")
			}

            if (data.value <  moment(d).format("YYYY-MM")) {
                data.disabled = true
            }

			this.options.push(data) 
		}
	},
    async mounted(){
        await this.getBilling()
        await this.getTrx()
        await this.loadConsumen();
        await this.getUsageSession();
    },
    watch:{
        billing: function() {
            this.dataBilling = this.billing
        },
        totalBilling: function() {
            this.dataTotalBilling = this.totalBilling
        },
        number: function() {
            this.dataNumber = this.number
        },
        loadingInvoice: function() {
            this.loadingInv = this.loadingInvoice
        }
    }
}
</script>
<style lang="scss">
.toolbar-mon {
    max-width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}
.header-text{
	font-weight: 700;
	color: #000;
	opacity: 0.7;
}

.wa-number{
    font-size: 1em;
}

.el-table {
    .cell-custom {
        padding: 15px 0;
    }

    thead.is-group{
        th {
            text-align: center;
        }    
    } 
        
    // th > .cell {
    //     text-align: center;
    // }
}

.el-table--group::after, .el-table--border::after {
    width: 0%;
}

</style>

